import axios from "@/plugins/axios";
import files from "./files";
import applications from "./applications";

let url = "/api/v1/services";

export default {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    files,
    applications,
};
